import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgCalculator({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 2a3 3 0 013 3v14a3 3 0 01-3 3H6a3 3 0 01-3-3V5a3 3 0 013-3h12zm0 2H6a1 1 0 00-1 1v14a1 1 0 001 1h12a1 1 0 001-1V5a1 1 0 00-1-1zm-2 12a1 1 0 110 2 1 1 0 010-2zm-4 0a1 1 0 110 2H8a1 1 0 110-2h4zm-4-4a1 1 0 110 2 1 1 0 010-2zm8 0a1 1 0 110 2 1 1 0 010-2zm-4 0a1 1 0 110 2 1 1 0 010-2zm4-6a1 1 0 011 1v2a1 1 0 01-1 1H8a1 1 0 01-1-1V7a1 1 0 011-1h8z"
        fill={color}
      />
    </svg>
  )
}

export default SvgCalculator
